<app-invoice-preview [invoice]="invoice"></app-invoice-preview>
